<sc-flex [fitHeight]="true" [vertical]="true" [stretchContent]="true">

  <sc-dialog-title>
    {{'Attach/Detach' | translate: ['tmc.transport-attach-detach.dialog.title' , translationService.language]}}
  </sc-dialog-title>

  <app-transport-info-panel [carrier]="stepperModel.workingData.carrier"
    [identifier]="stepperModel.workingData.identifier" [driver]="stepperModel.workingData.driver"
    [scope]="stepperModel.workingData.transportScope"></app-transport-info-panel>

  <sc-flex-fitting-content [vertical]="true">
    <sc-padding [fitHeight]="true">
      <app-select-action *ngIf="isActionSelection()"></app-select-action>
      <app-detach-truck-and-trailer *ngIf="isDetachTruckAndTrailer()">
      </app-detach-truck-and-trailer>
      <app-detach-truck *ngIf="isDetachTruck()"></app-detach-truck>
      <app-detach-trailer *ngIf="isDetachTrailer()"></app-detach-trailer>
      <app-detach-trailer-semi-trailer-truck
        *ngIf="isDetachTrailerFromSemiTrailerTruck()"></app-detach-trailer-semi-trailer-truck>
      <app-attach-truck *ngIf="isAttachTruck()"></app-attach-truck>
      <app-attach-trailer *ngIf="isAttachTrailer()"></app-attach-trailer>
      <app-select-trailer-swap-target *ngIf="isSelectTrailerSwapTarget()"></app-select-trailer-swap-target>
      <app-trailer-swap-source-details *ngIf="isTrailerSwapSourceDetails()"></app-trailer-swap-source-details>
    </sc-padding>
  </sc-flex-fitting-content>

  <app-service-response [responseMessages]="responseMessages"></app-service-response>

  <sc-actionbar>
    <button mat-stroked-button (click)="showPreviousStep()" *ngIf="isPreviousStepVisible()">{{'previous' | translate :
      ['tmc.transport-attach-detach.dialog.action.previous', translationService.language]}}</button>
    <sc-content-spacer [grow]="true"></sc-content-spacer>
    <button mat-stroked-button class="cancel-button" mat-dialog-close>{{'cancel' | translate:
      ['tmc.transport-attach-detach.dialog.action.cancel', translationService.language]}}</button>
    <sc-content-spacer></sc-content-spacer>
    <button mat-flat-button (click)="showNextStep()" class="confirm-button" [disabled]="!stepCompleted()"
      *ngIf="showNextStepButtonVisible()">{{'next' | translate: ['tmc.transport-attach-detach.dialog.action.next',
      translationService.language]}}</button>
    <button mat-flat-button (click)="finish()" *ngIf="showFinishButtonVisible()" class="confirm-button"
      [disabled]="actionRunning || !stepCompleted()">{{'finish' | translate :
      ['tmc.transport-attach-detach.dialog.action.finish', translationService.language]}}</button>
  </sc-actionbar>

</sc-flex>